// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/css/bootstrap.min.css'
import jquery from 'jquery'
import '../static/js/bootstrap.min.js'
import './assets/common.css'
import './assets/swiper-4.2.6.min.css'
import Swiper from '../static/swiper-4.2.6.min.js'

import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
import promise from 'es6-promise'
// 图片查看器
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(preview)

Vue.prototype.$swiper = Swiper
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.$moment = moment
promise.polyfill()

Vue.config.productionTip = false
// Vue.prototype.$url = 'http://localhost.deltaasiaquizwebbackend.com/api/'
// axios.defaults.baseURL = 'http://localhost.deltaasiaquizwebbackend.com/api/'
Vue.prototype.$url = 'http://backend.delta-asia-quiz.com/api/'
axios.defaults.baseURL = 'http://backend.delta-asia-quiz.com/api/'
axios.defaults.withCredentials = true
// 返回顶部函数
Vue.prototype.goTop = function () {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
}
Vue.filter('datefmt',function (input,fmtstring) {
  // 使用momentjs这个日期格式化类库实现日期的格式化功能
  return moment(input).format(fmtstring)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js